import { redirect } from '@tanstack/react-router'

import { stockPricesQuerySchema } from '@/schemas/prices'

/**
 * The `/market/prices` loader: Stock Prices is `/market/stock-prices` now (the mock's own path),
 * and an old link or bookmark keeps its `?query=&sortBy=&page=`. Always throws, so a replace
 * keeps the dead URL out of the back stack.
 */
export function loadStockPricesRedirect({ location }: { location: { search: unknown } }): never {
  // eslint-disable-next-line @typescript-eslint/only-throw-error
  throw redirect({
    to: '/market/stock-prices',
    search: stockPricesQuerySchema.parse(location.search),
    replace: true,
  })
}
